import React, { useEffect, useState } from "react";
import { apiRequest } from "../apiService/allapi";

function Media() {
  const API_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [mediaData, setMediaData] = useState([]);
  const getMedia = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/AppInfo/getMedia", "GET", null, {
        Authorization: `Bearer ${token}`,
      });
      console.log(res.data.data);
      if (res?.data?.status === "success") {
        setMediaData(res.data.data);
      }
    } catch (error) {
      console.log("Media API Error:", error);
    }
  };

  useEffect(() => {
    getMedia();
  }, []);

  const videoData = mediaData.filter((item) => item.mediaType === "Video");

  const photoData = mediaData.filter((item) => item.mediaType === "Photo");

  const getYoutubeId = (url) => {
    if (!url) return "";

    const parts = url.split("v=");
    return parts[1] || "";
  };
console.log(
 `${API_BASE_URL}Upload/ProductImages/PMedium/3.webp`
);
  return (
    <div className="media-page">
      <div className="container">
        {/* ================= VIDEOS ================= */}

        <div className="media-heading">
          <h2>Youtube Videos</h2>
          <p>Watch Our Latest Videos</p>
        </div>

        <div className="row mb-5">
          {videoData.length > 0 ? (
            videoData.map((item) => (
              <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
                <div className="video-card">
                  <iframe
                    className="video-frame"
                    src={`https://www.youtube.com/embed/${getYoutubeId(
                      item.mediaLink,
                    )}`}
                    title={item.subject}
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>

                  <div className="video-content">
                    <span className="video-badge">Video</span>

                    <h4>{item.subject}</h4>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <h4 className="text-center">No Videos Found</h4>
          )}
        </div>

        {/* ================= GALLERY ================= */}

        <div className="media-heading">
          <h2>Gallery</h2>
          <p>Our Latest Photos Collection</p>
        </div>

        <div className="row">
          {photoData.length > 0 ? (
            photoData.map((item) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={item.id}>
                <div className="gallery-card">
                  <img
                    src={`${API_BASE_URL}Upload/ProductImages/PMedium/${item.mediaLink}`}
                    alt={item.subject}
                  />

                  <div className="gallery-overlay">
                    <span className="gallery-badge">Photo</span>

                    <h5>{item.subject}</h5>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <h4 className="text-center">No Photos Found</h4>
          )}
          
        </div>
      </div>
    </div>
  );
}

export default Media;
